import { render, staticRenderFns } from "./BillingButtons.vue?vue&type=template&id=0b7c4217&scoped=true"
import script from "./BillingButtons.vue?vue&type=script&lang=js"
export * from "./BillingButtons.vue?vue&type=script&lang=js"
import style0 from "./BillingButtons.vue?vue&type=style&index=0&id=0b7c4217&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c4217",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7c4217')) {
      api.createRecord('0b7c4217', component.options)
    } else {
      api.reload('0b7c4217', component.options)
    }
    module.hot.accept("./BillingButtons.vue?vue&type=template&id=0b7c4217&scoped=true", function () {
      api.rerender('0b7c4217', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/BillingButtons.vue"
export default component.exports